// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Micronesia */
const FM =
  /^(?:31(?:00[67]|208|309)\d\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\d)\d)\d{3})$/;

export default FM;
